import React from 'react';
import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export type SwitchLabelProps = FormControlLabelProps;

const labelStyles = {
  m: 0,
  gap: 0.75,
  alignItems: 'center',
};

const SwitchLabel = React.forwardRef<
  HTMLLabelElement,
  SwitchLabelProps
>(({ sx, ...props }, ref) => {
  const combinedStyles = (sx
    ? [labelStyles, sx]
    : labelStyles) as SxProps<Theme>;

  return <FormControlLabel {...props} ref={ref} sx={combinedStyles} />;
});

SwitchLabel.displayName = 'SwitchLabel';

export { SwitchLabel };
